import { createContext } from 'react'

/**
 * A person's photo URL, by id or name, or undefined.
 *
 * Its own context rather than read off `useAppData`, because `Avatar` is drawn
 * everywhere — including screens outside the data provider, like sign-in — and
 * a missing photo is the right answer there, not a thrown error.
 */
export const PhotoContext = createContext<(idOrName: string) => string | undefined>(() => undefined)
